import { PrescreenTypes } from 'global';
import { AftermarketLicenceType } from '@trnsact/trnsact-shared-types';

import { configurableItemsTypes, documentsByKey, portalConfigurationTypes } from '../pages/Prequal/constants';
import { nonCreditMgrsRoles, vendorContactRole, vendorContactRole as vendorContactRoles } from '../utils';
import { portalDefaultConfigDealer, portalDefaultConfigLender } from 'modules/portalConfigurations/portal';
import { routingAccessDefaultConfig } from 'modules/portalConfigurations/routingAccess';

import _ from 'lodash';

const rolesSettingsKeys = {
  masked: 'masked',
  hidden: 'hidden',
  readOnly: 'readOnly',
  hiddenOnPDF: 'hiddenOnPDF',
  reportsHidden: 'reportsHidden',
  assignedOnly: 'assignedOnly',
  locationBased: 'locationBased',
  documentsByTypeSettingsHidden: 'documentsByTypeSettingsHidden',
  notificationsManagementHidden: 'notificationsManagementHidden',
  recertificationManagementHidden: 'recertificationManagementHidden',
  internalCreditTiersManagementHidden: 'internalCreditTiersManagementHidden',
  lenderPortalSetupPageHidde: 'lenderPortalSetupPageHidde',
  cadmReadOnly: 'cadmReadOnly',
  disallowVoСreation: 'disallowVoСreation',
  // Prescreen
  prescreenType: 'prescreenType',
  hiddenPrescreenPage: 'hiddenPrescreenPage',
  hiddenPrescreenResults: 'hiddenPrescreenResults',
  hiddenPrescreenSubmissionAccess: 'hiddenPrescreenSubmissionAccess',
  hiddenPrescreenScorecardBuilder: 'hiddenPrescreenScorecardBuilder',
};

const rolesSettingsHumanReadable = {
  [rolesSettingsKeys.masked]: 'Masked',
  [rolesSettingsKeys.hidden]: 'Hidden',
  [rolesSettingsKeys.readOnly]: 'Read-only',
  [rolesSettingsKeys.hiddenOnPDF]: 'Hidden On PDF',
  [rolesSettingsKeys.reportsHidden]: 'Reports Hidden',
  [rolesSettingsKeys.assignedOnly]: 'Assigned Only',
  [rolesSettingsKeys.locationBased]: 'Location Based',
  [rolesSettingsKeys.documentsByTypeSettingsHidden]: 'Documents By Type Settings Hidden',
  [rolesSettingsKeys.notificationsManagementHidden]: 'Notifications Management Hidden',
  [rolesSettingsKeys.recertificationManagementHidden]: 'Recertification Management Hidden',
  [rolesSettingsKeys.internalCreditTiersManagementHidden]: 'Internal Credit Tiers Management Hidden',
  [rolesSettingsKeys.lenderPortalSetupPageHidde]: 'Lender Portal Setup Page Hidden',
  // Prescreen
  [rolesSettingsKeys.prescreenType]: 'Module type',
  [rolesSettingsKeys.hiddenPrescreenPage]: 'Prescreen page hidden will be for',
  [rolesSettingsKeys.hiddenPrescreenResults]: 'Prescreen results hidden for',
  [rolesSettingsKeys.hiddenPrescreenSubmissionAccess]: 'Submission Access hidden for',
};

const getItemDefaultRolesSettings = (itemType, additionalParams) => {
  const getFieldRolesSettings = () => {
    return {
      [rolesSettingsKeys.masked]: [],
      [rolesSettingsKeys.hidden]: [],
      [rolesSettingsKeys.readOnly]: [],
      [rolesSettingsKeys.hiddenOnPDF]: [],
    };
  };

  const getBlockRolesSettings = () => {
    return {
      [rolesSettingsKeys.hidden]: [],
      [rolesSettingsKeys.readOnly]: [],
      [rolesSettingsKeys.hiddenOnPDF]: [],
    };
  };

  const getSectionRolesSettings = getBlockRolesSettings;

  const getModalRolesSettings = () => {
    return {
      [rolesSettingsKeys.hidden]: [],
      [rolesSettingsKeys.readOnly]: [],
      [rolesSettingsKeys.hiddenOnPDF]: [],
    };
  };

  const getScorecardSettings = () => {
    return {
      [rolesSettingsKeys.hidden]: nonCreditMgrsRoles,
      [rolesSettingsKeys.reportsHidden]: nonCreditMgrsRoles,
    };
  };

  const getLeadsSettings = () => {
    return {
      [rolesSettingsKeys.hidden]: [],
      /*       [rolesSettingsKeys.readOnly]: [], */
      [rolesSettingsKeys.assignedOnly]: [vendorContactRoles.sales_rep],
      [rolesSettingsKeys.locationBased]: [],
    };
  };

  const getOpportunitiesSettings = () => {
    return {
      /*       [rolesSettingsKeys.readOnly]: [], */
      [rolesSettingsKeys.assignedOnly]: [],
      [rolesSettingsKeys.locationBased]: [],
    };
  };

  const getUserManagementSettings = () => {
    return {
      [rolesSettingsKeys.hidden]: [vendorContactRoles.sales_rep],
      [rolesSettingsKeys.readOnly]: [],
    };
  };

  const getSecurityManagementSettings = () => {
    return {
      [rolesSettingsKeys.assignedOnly]: [],
    };
  };

  const getAftermarketManagementSettings = () => {
    return {
      [rolesSettingsKeys.assignedOnly]: [],
      [rolesSettingsKeys.readOnly]: [],
    };
  };

  const getHealthCheckSettings = () => {
    return {
      [rolesSettingsKeys.hidden]: [],
    };
  };

  const getCreditReportsSettings = () => {
    return {
      [rolesSettingsKeys.hidden]: [],
    };
  };

  const getVoManagementSettings = () => {
    return {
      [rolesSettingsKeys.cadmReadOnly]: [],
      [rolesSettingsKeys.disallowVoСreation]: nonCreditMgrsRoles,
    };
  };

  const getDocumentsByTypeSettings = additionalParams => {
    const docKey = additionalParams.docSettings.key;
    const userRolesDefaultHiddenByDocKeys = {
      [documentsByKey.bank_statements.key]: [vendorContactRoles.sales_rep, vendorContactRoles.sales_mgr],
      [documentsByKey.tax_returns.key]: [vendorContactRoles.sales_rep, vendorContactRoles.sales_mgr],
      [documentsByKey.credit_report.key]: [vendorContactRoles.sales_rep, vendorContactRoles.sales_mgr],
      [documentsByKey.compliance.key]: [vendorContactRoles.sales_rep, vendorContactRoles.sales_mgr],
    };
    return {
      [rolesSettingsKeys.hidden]: userRolesDefaultHiddenByDocKeys[docKey]
        ? userRolesDefaultHiddenByDocKeys[docKey]
        : [],
    };
  };

  const getPortalSetupSettings = () => {
    return {
      [rolesSettingsKeys.hidden]: [vendorContactRoles.sales_rep, vendorContactRoles.sales_mgr],
      [rolesSettingsKeys.documentsByTypeSettingsHidden]: [],
      [rolesSettingsKeys.notificationsManagementHidden]: [vendorContactRoles.sales_rep, vendorContactRoles.sales_mgr],
      [rolesSettingsKeys.recertificationManagementHidden]: [
        vendorContactRoles.sales_rep,
        vendorContactRoles.sales_mgr,
        vendorContactRoles.executive,
        vendorContactRoles.credit_mgr,
        vendorContactRoles.finance_mgr,
        vendorContactRoles.support_person,
      ],
      [rolesSettingsKeys.internalCreditTiersManagementHidden]: [],
      [rolesSettingsKeys.lenderPortalSetupPageHidde]: [
        vendorContactRoles.sales_rep,
        vendorContactRoles.sales_mgr,
        vendorContactRoles.admin,
        vendorContactRoles.it_admin,
        vendorContactRoles.executive,
        vendorContactRoles.credit_mgr,
        vendorContactRoles.finance_mgr,
        vendorContactRoles.support_person,
      ],
    };
  };

  const getPrescreenSettings = () => {
    return {
      [rolesSettingsKeys.prescreenType]: PrescreenTypes.Off,
      [rolesSettingsKeys.hiddenPrescreenPage]: Object.values(vendorContactRole),
      [rolesSettingsKeys.hiddenPrescreenResults]: Object.values(vendorContactRole),
      [rolesSettingsKeys.hiddenPrescreenSubmissionAccess]: Object.values(vendorContactRole),
      [rolesSettingsKeys.hiddenPrescreenScorecardBuilder]: Object.values(vendorContactRole),
    };
  };

  const getSubmissionsHubSettings = () => {
    return {
      [rolesSettingsKeys.assignedOnly]: [],
      [rolesSettingsKeys.locationBased]: [],
    };
  };

  const getInsuranceSettings = () => {
    return {
      [rolesSettingsKeys.hidden]: Object.values(vendorContactRoles),
    };
  };

  const getInventorySettings = () => {
    return {
      [rolesSettingsKeys.assignedOnly]: [],
      [rolesSettingsKeys.readOnly]: [],
    };
  };

  const getRolesSettingsByItemTypeHandlers = {
    [configurableItemsTypes.section]: getSectionRolesSettings,
    [configurableItemsTypes.block]: getBlockRolesSettings,
    [configurableItemsTypes.field]: getFieldRolesSettings,
    [configurableItemsTypes.modal]: getModalRolesSettings,
    [configurableItemsTypes.scorecard]: getScorecardSettings,
    [configurableItemsTypes.leads]: getLeadsSettings,
    [configurableItemsTypes.opportunities]: getOpportunitiesSettings,
    [configurableItemsTypes.userManagement]: getUserManagementSettings,
    [configurableItemsTypes.securityManagement]: getSecurityManagementSettings,
    [configurableItemsTypes.aftermarket]: getAftermarketManagementSettings,
    [configurableItemsTypes.healthCheck]: getHealthCheckSettings,
    [configurableItemsTypes.creditReports]: getCreditReportsSettings,
    //[configurableItemsTypes.documents]: getDocumentsSettings,
    [configurableItemsTypes.documentsByTypeSettings]: getDocumentsByTypeSettings,
    [configurableItemsTypes.portalSetup]: getPortalSetupSettings,
    [configurableItemsTypes.voManagement]: getVoManagementSettings,
    [configurableItemsTypes.prescreen]: getPrescreenSettings,
    [configurableItemsTypes.submissionsHubManagement]: getSubmissionsHubSettings,
    [configurableItemsTypes.insurance]: getInsuranceSettings,
    [configurableItemsTypes.inventory]: getInventorySettings,
  };
  return getRolesSettingsByItemTypeHandlers[itemType]
    ? getRolesSettingsByItemTypeHandlers[itemType](additionalParams)
    : null;
};

// TODO: Move getting default portal configurations to api-server!!!
const getDefaultPortalConfigurationByType = (type, vendorProfileId, isDealerUser = false) => {
  const getScorecardDefaulJSONDefinition = () => {
    return {
      config: {
        lenderProfileId: '',
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.scorecard),
      },
    };
  };

  const getLeadsDefaultJSONDefinition = () => {
    return {
      config: {
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.leads),
      },
    };
  };

  const getOpportunitiesDefaultJSONDefinition = () => {
    return {
      config: {
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.opportunities),
        allowManualVoCreation: false,
        allowSubmissionsV2: false,
        allowDealPipeline: false,
        hiddenInventorySearch: [],
      },
    };
  };

  const getUserManagementDefaultJSONDefinition = () => {
    return {
      config: {
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.userManagement),
      },
    };
  };

  const getSecurityManagementDefaultJSONDefinition = () => {
    return {
      config: {
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.securityManagement),
      },
    };
  };

  const getAftermarketManagementDefaultJSONDefinition = () => ({
    config: {
      rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.aftermarket),
      aftermarketLicenceType: AftermarketLicenceType.Core,
      allowCreateCustomProducts: false,
      partnerAllowSendProposals: false,
    },
  });

  const getHealthCheckDefaultJSONDefinition = () => {
    return {
      config: {
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.healthCheck),
      },
    };
  };

  const getCreditReportsDefaultJSONDefinition = () => {
    return {
      config: {
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.creditReports),
      },
    };
  };

  const getDocumentsDefaultJSONDefinition = () => {
    const getDocumentsByTypeDefaultSettings = () => {
      return _.reduce(
        documentsByKey,
        (result, docSettings) => {
          const docKeysHiddenForLendersByDefault = [
            documentsByKey.decision_letter.key,
            documentsByKey.credit_report.key,
          ];
          result[docSettings.key] = {
            rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.documentsByTypeSettings, { docSettings }),
            hiddenForLenders: _.includes(docKeysHiddenForLendersByDefault, docSettings.key),
          };
          return result;
        },
        {}
      );
    };

    return {
      config: {
        //rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.documents),
        creditAppHiddenForLenderProfileIds: [],
        //creditReportsHiddenForLenderProfileIds: [],
        documentsByTypeSettings: getDocumentsByTypeDefaultSettings(),
      },
    };
  };

  const getPortalSetupDefaultJSONDefinition = () => {
    return {
      config: {
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.portalSetup),
      },
    };
  };

  const getVoChecklistTemplateDefaultJSONDefinition = () => {
    return {
      config: {
        checklist: [],
        hidden: true, // Needs to be reworked in future to use rolesSettings (common approach) instead of just hidden prop
      },
    };
  };

  const getVoManagementDefaultJSONDefinition = () => {
    return {
      config: {
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.voManagement),
        deskingTabHiddenFor: [],
        submissionsTabHiddenFor: [],
        financeAndRevenueHiddenFor: [vendorContactRoles.sales_rep],
      },
    };
  };

  const getPrescreenDefaultJSONDefinition = () => {
    return {
      config: {
        ...getItemDefaultRolesSettings(configurableItemsTypes.prescreen),
      },
    };
  };

  const getSubmissionsHubDefaultJSONDefinition = () => {
    return {
      config: {
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.submissionsHubManagement),
      },
    };
  };

  const getInvoiceAndEquipmentDefaultJSONDefinition = () => {
    return {
      config: {
        allowInvoiceAndEquipmentV2: false,
      },
    };
  };

  const getInsuranceDefaultJSONDefinition = () => {
    return {
      config: {
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.insurance),
      },
    };
  };

  const getInventoryDefaultJSONDefinition = () => {
    return {
      config: {
        rolesSettings: getItemDefaultRolesSettings(configurableItemsTypes.inventory),
      },
    };
  };

  const getPortalDefaultJSONDefinition = () => {
    return {
      config: isDealerUser ? portalDefaultConfigDealer : portalDefaultConfigLender,
    };
  };

  const getRoutingAccessDefaultJSONDefinition = () => {
    return {
      config: routingAccessDefaultConfig,
    };
  };

  const getAiAssistantDefaultJSONDefinition = () => {
    return {
      config: { aiAssistantEnabled: false },
    };
  };

  const getDefaultJSONDefinitionByTypeHandlers = {
    [portalConfigurationTypes.scorecard]: getScorecardDefaulJSONDefinition,
    [portalConfigurationTypes.leads]: getLeadsDefaultJSONDefinition,
    [portalConfigurationTypes.opportunities]: getOpportunitiesDefaultJSONDefinition,
    [portalConfigurationTypes.userManagement]: getUserManagementDefaultJSONDefinition,
    [portalConfigurationTypes.securityManagement]: getSecurityManagementDefaultJSONDefinition,
    [portalConfigurationTypes.aftermarket]: getAftermarketManagementDefaultJSONDefinition,
    [portalConfigurationTypes.healthCheck]: getHealthCheckDefaultJSONDefinition,
    [portalConfigurationTypes.creditReports]: getCreditReportsDefaultJSONDefinition,
    [portalConfigurationTypes.documents]: getDocumentsDefaultJSONDefinition,
    [portalConfigurationTypes.portalSetup]: getPortalSetupDefaultJSONDefinition,
    [portalConfigurationTypes.voChecklistTemplate]: getVoChecklistTemplateDefaultJSONDefinition,
    [portalConfigurationTypes.voManagement]: getVoManagementDefaultJSONDefinition,
    [portalConfigurationTypes.prescreen]: getPrescreenDefaultJSONDefinition,
    [portalConfigurationTypes.submissionsHubManagement]: getSubmissionsHubDefaultJSONDefinition,
    [portalConfigurationTypes.invoiceAndEquipment]: getInvoiceAndEquipmentDefaultJSONDefinition,
    [portalConfigurationTypes.insurance]: getInsuranceDefaultJSONDefinition,
    [portalConfigurationTypes.inventory]: getInventoryDefaultJSONDefinition,
    [portalConfigurationTypes.portal]: getPortalDefaultJSONDefinition,
    [portalConfigurationTypes.routingAccess]: getRoutingAccessDefaultJSONDefinition,
    [portalConfigurationTypes.aiAssistant]: getAiAssistantDefaultJSONDefinition,
  };

  const defaultJSONDefinitionByType = getDefaultJSONDefinitionByTypeHandlers[type]
    ? getDefaultJSONDefinitionByTypeHandlers[type]()
    : null;

  return {
    vendorProfileId,
    type,
    jsonDefinition: defaultJSONDefinitionByType,
  };
};

const getHiddenDocumentsKeys = (documentsPortalConfiguration, userRole) => {
  return _(documentsPortalConfiguration)
    .chain()
    .get('jsonDefinition.config.documentsByTypeSettings')
    .pickBy((value, key) => _.includes(value.rolesSettings.hidden, userRole))
    .keys()
    .value();
};

const rejectHiddenDocumentTypeOptions = (documentsPortalConfiguration, documentTypeOptions, userRole) => {
  const documentsKeysHidden = getHiddenDocumentsKeys(documentsPortalConfiguration, userRole);
  return _.reject(documentTypeOptions, documentSetting => _.includes(documentsKeysHidden, documentSetting.key));
};

export {
  // methods
  getItemDefaultRolesSettings,
  getDefaultPortalConfigurationByType,
  //
  getHiddenDocumentsKeys,
  rejectHiddenDocumentTypeOptions,
  // constants
  rolesSettingsKeys,
  rolesSettingsHumanReadable,
};
